import { baseApi, getErrorMessage } from '@/shared/api';
import { mapSavedPreset } from '../libs/mapSavedPreset';
import type { SavedPresetRecord } from '../model/types';
import type { SavedPresetDTO, PresetViewType } from './types';

export const getSavedPresets = async (): Promise<SavedPresetRecord[]> => {
  const { data, error } = await baseApi.functions.invoke<{
    savedPresets: SavedPresetDTO[];
  }>('saved-presets', {
    method: 'GET',
  });

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return data.savedPresets.map(mapSavedPreset);
};

export const deleteSavedPreset = async (id: string) => {
  const { error } = await baseApi.functions.invoke(`saved-presets/${id}`, {
    method: 'DELETE',
  });

  if (error) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }
};

export const createSavedPreset = async ({
  viewType,
  name,
  preset,
  isDefault,
  isFavorite,
}: {
  viewType: PresetViewType;
  name: string;
  preset: unknown;
  isDefault: boolean;
  isFavorite: boolean;
}) => {
  const { data, error } = await baseApi
    .functions.invoke<{
      savedPreset: SavedPresetDTO;
    }>('saved-presets', {
      method: 'POST',
      body: {
        name,
        viewType,
        preset,
        isDefault,
        isFavorite,
      },
    });

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return mapSavedPreset(data.savedPreset);
};

export const updateSavedPreset = async (
  id: string,
  update: {
    name?: string;
    viewType?: PresetViewType;
    preset?: unknown;
    isDefault?: boolean;
    isFavorite?: boolean;
  }
) => {
  const { data, error } = await baseApi.functions.invoke<{
    savedPreset: SavedPresetDTO;
  }>(`saved-presets/${id}`, {
    method: 'PUT',
    body: {
      name: update.name,
      viewType: update.viewType,
      preset: update.preset,
      isDefault: update.isDefault,
      isFavorite: update.isFavorite,
    },
  });

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return mapSavedPreset(data.savedPreset);
};
